<template>
    <Autocomplete
        :fetch-keys="() => [['问题名称', 'question_name'], ['姓名', 'create_name']]"
        :fetch-options="getList"
        :label="params?.type == 1 ? 'content' : 'questionName'"
        v-bind="$attrs"
        @select="$router.push(`/question/quesDetail/${$event.id || $event.questionId}`)"
    />
</template>

<script setup>
import axios from '@/plugins/axios';
import Autocomplete from './Autocomplete.vue';

const props = defineProps({
    type: {
        type: String,
        default: ''
    },
    params: {
        type: Object,
        default: () => ({})
    }
});

function getList(keywords, keys) {
    return axios.post(`/question/query/${props.type}`, {
        sourceType: 'pc',
        ...props.params,
        pageNum: 1,
        pageSize: 50,
        keywords,
        keys
    })
        .then(e => e?.data?.list || []);
}
</script>
